(function() {
  'use strict';

  angular.module('app').factory('GroupService', GroupService);

  function GroupService(WebApiService) {
    return {
      getGroupList: function() {
        var queryString = {};

        var options = {
          ignoreLoadingBar: true
        };

        return WebApiService.get('/api/Group/GroupList', queryString, options);
      }
    };
  }
})();
